import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Generative AI Foundations & Modern AI Ecosystem",
    description:
      "Introduction to Generative AI,How it differs from traditional AI, Evolution from rule-based AI → ML → Deep Learning → GenAI, Overview of LLMs (Large Language Models) & Diffusion Models, Applications in content creation coding design automation and more, Understanding ethical AI bias & responsible use",
  },
  {
    title: "Python, Data Handling & AI Programming Essentials",
    description:
      "Python basics for AI workflows, Working with NumPy Pandas & data preprocessing, Tokenization embeddings & vectorization, Handling datasets for text image & audio generation, Writing reusable AI scripts & modules",
  },
  {
    title: "Deep Learning Fundamentals for GenAI",
    description:
      "Neural Networks CNNs RNNs Transformers, Backpropagation activation functions & loss calculation, GPU vs CPU processing, Training validation & evaluation of models, Intro to PyTorch/TensorFlow frameworks",
  },
  {
    title: "Large Language Models (LLMs) & Text Generation",
    description:
      "How LLMs work (attention mechanism tokens context), Prompt engineering & advanced prompting, Using models like GPT Llama Gemini Claude (API-based), Chatbots summarizers translators code generators, Fine-tuning & customizing LLMs for business use",
  },
  {
    title: "Image Generation Models & Diffusion Systems",
    description:
      "Understanding diffusion models (Stable Diffusion Midjourney DALL·E), Text-to-image & image-to-image concepts, ControlNet LoRA & personalization models, Creating artistic realistic & brand-specific visuals, Ethical considerations in image generation",
  },
  {
    title: "Speech, Audio & Video Generation with AI",
    description:
      "Text-to-speech (TTS) & voice cloning, Speech-to-text (STT) systems, AI music & sound design tools, AI video creation & animation fundamentals, Multimodal AI concepts (text → image → audio → video)",
  },
  {
    title: "Prompt Engineering Mastery for Real-World Use",
    description:
      "Prompt types: zero-shot few-shot chain-of-thought, Frameworks: RACE TREE TACO prompts, System prompts & role-based prompting, Creating structured outputs (JSON tables slide content), Designing high-quality prompts for business automation",
  },
  {
    title: "Building GenAI Applications & Automation Systems",
    description:
      "Using APIs to build GenAI-powered apps, Integrating LLMs with web apps (Flask FastAPI), Creating AI tools: chatbots assistants generators, Workflow automation with AI agents, Deploying GenAI apps on cloud platforms",
  },
  {
    title: "Responsible AI, Privacy, Security & Governance",
    description:
      "Data privacy & copyright considerations, Bias misinformation & hallucination control, Safe model usage & constraints, Enterprise AI compliance, Designing safe AI systems for real businesses",
  },
  {
    title: "Capstone Generative AI Project & Career Launchpad",
    description:
      "Build a complete GenAI project (chatbot, image generator, assistant, etc.), End-to-end: dataset → model → app → deployment, Create a strong AI/GenAI portfolio, Resume & LinkedIn optimization for AI roles, Interview prep for Prompt Engineer, GenAI Developer, AI Analyst roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
